// extracted by mini-css-extract-plugin
module.exports = {"letter":"WordBuilderView_letter__2-Agd","missing":"WordBuilderView_missing__2CN-g"};